import * as Yup from "yup";

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .min(3, "Minimum 3 Letters Required")
    .max(15, "Maximum 15 Letter Allowed")
    .required("Required Field"),
  lastName: Yup.string()
    .min(3, "Minimum 3 Letters Required")
    .max(15, "Maximum 15 Letter Allowed")
    .required("Required Field"),
  regulatoryFirm: Yup.string()
    .required("Required Field"),
  regulatoryNumber: Yup.string()
    .required("Required Field"),
  phoneNumber: Yup.string()
    .min(10, "Minimum 10 Digits Required")
    .max(15, "Maximum 15 Digits Allowed")
    .required("Required Field"),
  email: Yup.string().email("Invalid Email Address").required("Required Field"),
  password: Yup.string()
    .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)
    .required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Password is not matched")
    .required("Required Field"),
  file: Yup.mixed()
    .required("Required Field")
    .test("type", "Invalid file type. Supported file type is Pdf, Docx", (value) => {
      return value && value?.type === "application/pdf";
    }),
});
